module.exports = {
    language: {
        name: 'English'
    },
    user: {
        login:'登录/注册',
        logintext: '登录'
    },
    navMenu: {
        home: '首页',
        conference: '大会',
        exhibition: '展商',
        active: '活动',
        business: '商机',
        news: '新闻',
        mine: '我的',
    },
    home: {
        top: '回到顶部',
        more: '更多'
    },
    exhibitor: {
        demandTip:'需求描述',
        chooseLabel:'已选项目',
        filter: '筛选',
        search: '搜索展商',
        productGroups: '产品类别',
        countryRegion: '国家／地区',
        reset: '重置',
        searchresult: '查看结果',
        session: '届次',
        placeholder: '请输入公司名称或展位号',
        searchProduct: '搜索产品',
        placeholderProduct: '请输入产品名称',
        all:'全部',
        release:'发布需求',
        Inbox:'收件箱',
        description:'需求阐述',
        answer:'应答',
        people:'人',
        statusOne:'采购类',
        statusTwo:'供应类',
        personal:'个人资料',
        collect:'我的收藏',
        demand:'我的需求',
        product:'产品',
        enterprise:'企业',
        sendDemand:'发出需求',
        myAnswer:'我的应答',
        enterpriseMessage:'企业留言',
        feedback:'意见反馈',
        hotline:'技术热线',
        exhibitorVerification:'展商验证',
        demandMessage:'需求留言',
        favourite:'收藏',
        cancel:'取消收藏',
        companyProfile:'公司简介',
        tapLookCall:'点击查看联系方式',
        productBrief:'产品简介',
        brandName:'品牌名称',
        protection:'环保证书',
        endUse:'最终用途',
        companyType:'展商类型',
        certification:'产品认证',
        priceRange:'价格范围',
        proxy:'寻求代理',
        dexport:'出口国家和地区',
        market:'内销市场希望开拓的地区',
        contact:'联系方式',
        ProductDescription:'产品',
        businessDetails:'展商详情',
        productDetails:'产品详情',
        otherProducts:'其他产品',
        activeDetails:'活动详情',
        productInformation: '产品',
        live:'进入直播间',
    },
    business: {
        sex:'性别',
        man:'先生',
        woman:'女士',
        Mis:'小姐',
        country:'国家／地区',
        city:'城市',
        mineText:'Please fill in your personal information to continue the Online Business Matching progress.',
        demandDetails:'需求详情',
        businessMode:'贸易属性',
        multi:'（可多选）',
        trade:'中国国内贸易',
        internationalTrade:'国际贸易',
        demandTag:'需求标签',
        demandPhoto:'需求图片',
        demandMessage:'需求描述',
        repayList:"应答列表",
        respond:'应答',
        waiting:'等待回应中',
        receivedResponse:'对方将通过电话联系您！',
        deleteRequest:'删除需求',
        retrieveRequest:'暂停发布',
        personalInformation:'请完善您的个人资料',
        nickname:'姓名',
        mobile:'手机',
        email:'电子邮件',
        companyName:'公司名称',
        businessNature:'行业属性',
        deportment:'部门属性',
        jobLevel:'职务级别',
        save:'保存',
        choose:'请选择',
        inputContents:'请输入内容',
        fillRequest:'填写您的需求信息',
        buyer:'我寻找产品或资源',
        exhibitor:'我提供产品或资源',
        chinese:'中文',
        publish:'发布',
        role:'需求属性',
        edit: '编辑',
        opinionType: '请在这里输入意见反馈',
        demandType:'请在此输入您的需求内容',
        submit: '提交',
        answerMessage: '应答留言',
        call: '致电',
        inboxs:'企业收件箱',
        replyMessage:'留言',
        liaison:'联络',
    },
    login:{
        login: '登录',
        register: '注册',
        messageLogin: '短信登录',
        newRegister: '新用户注册',
        username: '邮箱地址/手机号',
        userEmail:'邮箱地址',
        password: '密码',
        read: '阅读协议并同意',
        userPolicy:'《用户协议与',
        policy: '隐私政策》',
        usernameLogin: '账号密码登录',
        getCode: '获取验证码',
        verifiyCode: '验证码',
        already: '已有账户登录',
        confirmWords: '拖动滑块验证',
        verifyEmail:'设置密码',
        repaceCode:'账号已经存在，请直接登陆',
        sure:'确定',
        cancel:'取消',
        forget:'忘记密码',
        verificationSuccess:'验证通过',//验证通过
    }
}